

















































import { computed, ComputedRef, defineComponent } from '@vue/composition-api';
import { SoDepth } from '@/store/types';

function createDepth() {
	return {
		minValue: 0,
		maxValue: 0,
		unit: 'unit:CM',
	};
}

const modifyDepth = (depth: Depth, key: keyof Depth) => (value: string | number): Depth => {
	return {
		...depth,
		[key]: value,
	};
};

interface Depth {
	maxValue: number;
	minValue: number;
	unit: string;
}

export default defineComponent({
	props: {
		items: {
			type: Array as () => SoDepth[],
			default: [],
		},
		single: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	setup(props, { emit }) {
		const depths: ComputedRef<Depth[]> = computed(() =>
			props.items.map((depth: SoDepth) => ({
				minValue: depth.minValue.value,
				maxValue: depth.maxValue.value,
				unit: depth.minValue.unit || depth.maxValue.unit,
			}))
		);

		const units = [
			{
				value: 'unit:CM',
				text: 'cm',
			},
			{
				value: 'unit:IN',
				text: 'in',
			},
		];

		function emitDepths(depths: Depth[]) {
			emit(
				'setDepths',
				depths.map((depth: Depth) => ({
					minValue: {
						value: depth.minValue,
						unit: depth.unit,
					},
					maxValue: {
						value: depth.maxValue,
						unit: depth.unit,
					},
				}))
			);
		}

		function onAddDepth() {
			const newDepths = [...depths.value, createDepth()];
			emitDepths(newDepths);
		}

		const onEditDepth = (index: number) => (depth: Depth) => {
			const newDepths = [...depths.value.slice(0, index), depth, ...depths.value.slice(index + 1)];
			emitDepths(newDepths);
		};

		const onRemoveDepth = (index: number) => {
			const newDepths = [...depths.value.slice(0, index), ...depths.value.slice(index + 1)];
			emitDepths(newDepths);
		};

		return {
			depths,
			units,
			onAddDepth,
			onRemoveDepth,
			onEditDepth,
			modifyDepth,
		};
	},
});
